module.exports = __webpack_public_path__ + "img/result_analysis.0bdb027a.svg";